// src/pages/ChiTieu.js
import React, { useState, useEffect, useCallback } from "react";
import { fetchData, addData, updateData, deleteData, guiAnh } from "../services/api";
import { useThongBao, ThongBao, DangTai, docQuyen, hoiXoa } from "../vo";
import KhoiChiTieu from "../components/KhoiChiTieu";
import AnhCoKhoa from "../components/AnhCoKhoa";
import { veTien, docSoTien, veTenThang } from "../utils/tien";
import { thuNhoAnh, veDungLuong } from "../utils/thuNhoAnh";

// ============================================================
// 💰 BÁO CHI TIÊU — trang đầy đủ (Đợt 5C)
// ------------------------------------------------------------
// Bảng tin chỉ hiện bản tin THÁNG MỚI NHẤT, chỉ để đọc. Trang này là chỗ
// Ba Mẹ soạn bản tin và xem lại các tháng cũ.
//
// ⚠️ ĐÂY KHÔNG PHẢI APP KẾ TOÁN. Chủ nhà đã có app thu chi riêng.
// Mỗi tháng gõ 3–5 dòng, một lần, ít hơn cả chụp ảnh dán lên Zalo.
// Đừng thêm phân loại, biểu đồ, ngân sách hay nhắc nhập hằng ngày —
// thêm vào là nó chết như mọi app kế toán khác.
//
// ⚠️ Các component con nằm NGOÀI hàm ChiTieu — xem bài học
// docs/bai-hoc/2026-09-07-06_ham-trong-ham-lam-mat-con-tro.md
// ============================================================

// Mặc định là tháng hiện tại, tính theo giờ MÁY NGƯỜI DÙNG (đủ đúng cho
// một ô chọn tháng). Không dùng toISOString() — nó cho giờ UTC và từ 0h
// đến 7h sáng giờ ta, ngày mùng 1 sẽ lùi về tháng trước.
const thangNay = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

// ============================================================
// 📷 GẮN ẢNH HOÁ ĐƠN VÀO TỪNG KHOẢN (Đợt N5, anh chốt 14/09 — câu 2)
// ------------------------------------------------------------
// Ô chọn tệp `accept="image/*"` KHÔNG kèm `capture`: có `capture` thì điện
// thoại mở thẳng máy ảnh, mất đường chọn ảnh hoá đơn đã chụp sẵn trong thư
// viện. Không kèm thì điện thoại hỏi "Chụp ảnh hay Chọn từ thư viện".
//
// "✕ bỏ ảnh" chỉ gỡ ảnh khỏi khoản — tệp ảnh vẫn nằm trong kho tháng trên VPS
// (không có chỗ nào tự xóa ảnh, trừ nút Dọn trong Quản trị). Nên không hỏi lại.
// ============================================================
function NutAnhKhoan({ k, dangGui, onGanAnh, onBoAnh }) {
  const coAnh = k.anh_id && !k.anh_da_don;
  return (
    <>
      {coAnh && <AnhCoKhoa anhId={k.anh_id} moTa={`Hoá đơn ${k.ten}`} className="ct-anh-nho" />}
      {k.anh_id && k.anh_da_don && <span className="anh-da-cat">🗂️ ảnh đã cất</span>}
      {coAnh ? (
        <button onClick={onBoAnh} className="ct-nut-bo-anh" disabled={Boolean(dangGui)}>
          ✕ bỏ ảnh
        </button>
      ) : (
        <label className={`ct-nut-gan-anh ${dangGui ? "ct-nut-tat" : ""}`}>
          📷 Gắn ảnh
          <input
            type="file"
            accept="image/*"
            disabled={Boolean(dangGui)}
            onChange={(e) => {
              const tep = e.target.files && e.target.files[0];
              e.target.value = ""; // chọn lại đúng tấm đó lần nữa vẫn chạy
              if (tep) onGanAnh(tep);
            }}
          />
        </label>
      )}
    </>
  );
}

function DongKhoan({ k, dangSua, ten, soTien, onDoiTen, onDoiSo, onMoSua, onLuu, onHuy, onXoa, suaDuoc, dangGuiAnh, onGanAnh, onBoAnh }) {
  if (dangSua) {
    return (
      <li className="ct-dong-khoan ct-dong-khoan-sua">
        <input
          type="text"
          value={ten}
          onChange={(e) => onDoiTen(e.target.value)}
          placeholder="Tên khoản"
          maxLength={100}
          className="ct-o"
          autoFocus
        />
        <input
          type="text"
          inputMode="numeric"
          value={soTien}
          onChange={(e) => onDoiSo(e.target.value)}
          placeholder="Số tiền"
          className="ct-o ct-o-tien"
        />
        <button onClick={onLuu} className="nut nut-xanh">Lưu</button>
        <button onClick={onHuy} className="nut nut-xam">Thôi</button>
      </li>
    );
  }
  return (
    <li className="ct-dong-khoan">
      <span className="ct-ten-khoan">{k.ten}</span>
      <span className="ct-so-tien">{veTien(k.so_tien)}</span>
      {suaDuoc && (
        <span className="ct-nut">
          <NutAnhKhoan k={k} dangGui={dangGuiAnh} onGanAnh={onGanAnh} onBoAnh={onBoAnh} />
          <button onClick={onMoSua} className="btn-edit" title="Sửa">✏️</button>
          <button onClick={onXoa} className="btn-delete" title="Xóa">🗑️</button>
        </span>
      )}
      {dangGuiAnh && (
        <div className="ct-dang-gui-anh" role="status">
          ⏳ <strong>{dangGuiAnh}</strong>
          <div className="ct-thanh-cho"><div /></div>
        </div>
      )}
    </li>
  );
}

// ============================================================
// ⌨️ ĐIỀN SỐ HÀNG LOẠT
// ------------------------------------------------------------
// Ý của chủ nhà: "nhà nào cũng có những khoản chi cố định hàng tháng,
// cái này giúp được tôi nè, lúc đó, chỉ điền số thôi."
//
// Tạo bản tin tháng mới có tick "chép khoản tháng trước" thì các khoản
// hiện ra sẵn với số 0, và màn hình này mở luôn: TÊN để nguyên, chỉ có ô
// số. Gõ hết rồi bấm một nút Lưu tất cả.
//
// Cố ý CHỈ CHÉP TÊN, không chép số tiền — xem khối ghi chú ở server.js.
// Bỏ trống một khoản thì khoản đó giữ nguyên 0, không đụng tới; tháng
// này không đóng tiền rác thì cứ bỏ trống.
//
// ⚠️ Component này nằm NGOÀI hàm ChiTieu. Đặt bên trong thì mỗi lần gõ
// một chữ là cả danh sách bị tháo ra dựng lại và con trỏ nhảy chỗ —
// xem docs/bai-hoc/2026-09-07-06_ham-trong-ham-lam-mat-con-tro.md
// ============================================================
function DienNhanh({ tenThang, khoan, soDien, onDoiSo, onLuu, onThoi, dangLuu }) {
  return (
    <div className="ct-dien-nhanh">
      <p className="ct-nhan-khoi">Điền số cho {tenThang}</p>
      <p className="ct-dien-nhanh-nhac">
        Các khoản đã chép sẵn từ tháng trước — chỉ việc điền số.
        Khoản nào tháng này không có thì cứ bỏ trống.
      </p>
      <ul className="ct-danh-sach-khoan">
        {khoan.map((k, i) => (
          <li key={k.id} className="ct-dong-dien">
            <label className="ct-ten-khoan" htmlFor={`dien-${k.id}`}>
              {k.ten}
            </label>
            <input
              id={`dien-${k.id}`}
              type="text"
              inputMode="numeric"
              value={soDien[k.id] === undefined ? "" : soDien[k.id]}
              onChange={(e) => onDoiSo(k.id, e.target.value)}
              placeholder="0"
              className="ct-o ct-o-tien"
              autoFocus={i === 0}
            />
          </li>
        ))}
      </ul>
      <div className="ct-hang-nut">
        <button onClick={onLuu} className="nut nut-xanh" disabled={dangLuu}>
          {dangLuu ? "Đang lưu…" : "Lưu tất cả"}
        </button>
        <button onClick={onThoi} className="nut nut-xam">Để sau</button>
      </div>
    </div>
  );
}

function ChiTieu({ user }) {
  const [ds, setDs] = useState([]);
  const [dangTai, setDangTai] = useState(true);

  const [moThang, setMoThang] = useState(false);
  const [thangMoi, setThangMoi] = useState(thangNay());
  const [chepKhoan, setChepKhoan] = useState(true);

  // Màn hình "điền số hàng loạt": tên khoản để nguyên, chỉ gõ số.
  const [dienNhanhId, setDienNhanhId] = useState(null);
  const [soDien, setSoDien] = useState({});
  const [dangLuuNhanh, setDangLuuNhanh] = useState(false);

  // Đang soạn cho bản tin nào (id) — thêm khoản mới
  const [themVao, setThemVao] = useState(null);
  const [tenKhoan, setTenKhoan] = useState("");
  const [soTienKhoan, setSoTienKhoan] = useState("");

  const [suaKhoanId, setSuaKhoanId] = useState(null);
  const [tenSua, setTenSua] = useState("");
  const [soSua, setSoSua] = useState("");

  const [suaLoiNhanId, setSuaLoiNhanId] = useState(null);
  const [loiNhanTam, setLoiNhanTam] = useState("");

  // ============================================================
  // Quyền riêng: chi_tieu.soan — MỘT ô lo cả tạo, sửa lẫn xóa.
  // KHÔNG dùng chung với bốn ô family (Xem/Thêm/Sửa/Xóa), vì bốn ô đó áp
  // cho mọi mục chung khác; muốn chặn các con sửa bản tin chi tiêu mà lại
  // phải bỏ quyền Sửa của chúng ở Việc nhà, Đi chợ, Danh bạ thì vô lý.
  // Xem khối ghi chú QUYEN_RIENG trong AdminPanel.js.
  // ============================================================
  const coTheSoan = docQuyen(user).rieng("chi_tieu", "soan");

  // 3500ms thay vì 3000 mặc định: thông báo ở trang này hay kèm số tiền,
  // đọc lâu hơn một dòng "Đã lưu".
  const { bao, noiBao } = useThongBao(3500);

  const taiLai = useCallback(async () => {
    try {
      const d = await fetchData("chi-tieu");
      setDs(Array.isArray(d) ? d : []);
    } catch (err) {
      noiBao("⚠️ Không tải được báo chi tiêu");
    } finally {
      setDangTai(false);
    }
    // `noiBao` được ghi nhớ trong useThongBao nên khai vào đây an toàn —
    // thời bản cũ nó là hàm mới mỗi lần vẽ, khai vào là tải lại vô tận.
  }, [noiBao]);

  useEffect(() => {
    taiLai();
  }, [taiLai]);

  // ============================================================
  // 💰 MỞ TRANG = ĐÃ XEM (Đợt N4, 14/09/2026)
  // ------------------------------------------------------------
  // Anh chốt (câu 4): lời nhắc "Ba báo cả nhà xem chi tiêu" nằm trên Bảng tin
  // của mỗi người TỚI KHI CHÍNH NGƯỜI ĐÓ VÀO XEM. Vào tới trang này là đã xem
  // — không bắt bấm thêm nút "tôi xem rồi" nào.
  //
  // Gọi một lần mỗi lần mở trang. Hỏng thì im lặng: tệ nhất là lời nhắc còn
  // nằm thêm một hôm, không đáng làm phiền người đang đọc số liệu.
  // ============================================================
  useEffect(() => {
    updateData("nhac-nho/chi-tieu", "da-xem", {}).catch(() => {});
  }, []);

  // 📋 N8 — tên khoản chi cố định (chủ nhà soạn ở ⚙️ Quản trị) để GỢI Ý khi gõ
  // tên khoản. Gõ đúng tên danh mục thì chỗ nhắc "tháng này chưa có…" không
  // báo động giả kiểu "Điện" vs "Tiền điện". Không soạn được thì khỏi hỏi.
  const [tenCoDinh, setTenCoDinh] = useState([]);
  useEffect(() => {
    if (!coTheSoan) return;
    fetchData("khoan-co-dinh/ten").then((d) => setTenCoDinh(Array.isArray(d) ? d : [])).catch(() => {});
  }, [coTheSoan]);

  // ============================================================
  // 📣 BÁO CẢ NHÀ VÀO XEM (Đợt N4)
  // ------------------------------------------------------------
  // Anh chốt 09/09: khối chi tiêu thôi nằm thường trực trên Bảng tin; thay
  // vào đó "Ba tự bấm báo cả nhà". Máy chủ ghi mỗi người một lời nhắc vào
  // hàng đợi `nhac_nho`, trừ chính người bấm.
  //
  // "Báo lại" hỏi trước một câu: bấm lại thì người ĐÃ XEM cũng bị nhắc lại,
  // lỡ tay là cả nhà nhận thêm một lời nhắc thừa.
  // ============================================================
  const [dangBao, setDangBao] = useState(null);

  const baoCaNha = async (t) => {
    if (
      t.da_bao_ca_nha &&
      !window.confirm(
        `Báo lại cho cả nhà xem ${veTenThang(t.thang_ma).toLowerCase()}?\n` +
          "Người đã xem rồi cũng sẽ được nhắc lại.",
      )
    ) {
      return;
    }
    setDangBao(t.id);
    try {
      const kq = await addData(`chi-tieu/${t.id}/bao-ca-nha`, {});
      await taiLai();
      noiBao(
        kq && kq.so_nguoi === 0
          ? "⚠️ Đã báo, nhưng trong nhà chưa ai khác được cấp quyền xem chi tiêu"
          : `✅ Đã báo cả nhà vào xem ${veTenThang(t.thang_ma).toLowerCase()}`,
      );
    } catch (err) {
      noiBao("⚠️ Chưa báo được — thử lại giúp nhé");
    } finally {
      setDangBao(null);
    }
  };

  const taoThang = async (e) => {
    if (e) e.preventDefault();
    if (!/^\d{4}-\d{2}$/.test(thangMoi)) {
      noiBao("⚠️ Chưa chọn tháng");
      return;
    }
    try {
      const moi = await addData("chi-tieu", { thang: thangMoi, chep_khoan: chepKhoan });
      setMoThang(false);
      await taiLai();
      // Chép được khoản nào thì mở luôn màn hình điền số — đúng ý chủ nhà:
      // "nhà nào cũng có những khoản chi cố định hàng tháng… lúc đó, chỉ
      // điền số thôi."
      if (moi && Array.isArray(moi.khoan) && moi.khoan.length > 0) {
        setDienNhanhId(moi.id);
        setSoDien({});
      }
    } catch (err) {
      // Máy chủ trả 409 khi tháng đã có bản tin. Nói đúng chuyện đó ra.
      noiBao("⚠️ Không tạo được — có thể tháng này đã có bản tin rồi");
    }
  };

  const themKhoan = async (e, thangId) => {
    if (e) e.preventDefault();
    const ten = tenKhoan.trim();
    const so = docSoTien(soTienKhoan);
    if (ten === "") {
      noiBao("⚠️ Chưa nhập tên khoản");
      return;
    }
    if (so === "") {
      noiBao("⚠️ Chưa nhập số tiền");
      return;
    }
    try {
      await addData(`chi-tieu/${thangId}/khoan`, { ten, so_tien: so });
      setTenKhoan("");
      setSoTienKhoan("");
      await taiLai();
    } catch (err) {
      noiBao("⚠️ Không thêm được khoản này");
    }
  };

  const luuKhoan = async (k) => {
    const ten = tenSua.trim();
    const so = docSoTien(soSua);
    if (ten === "") {
      noiBao("⚠️ Tên khoản không được để trống");
      return;
    }
    if (so === "") {
      noiBao("⚠️ Số tiền không hợp lệ");
      return;
    }
    try {
      await updateData("chi-tieu-khoan", k.id, { ten, so_tien: so });
      setSuaKhoanId(null);
      await taiLai();
    } catch (err) {
      noiBao("⚠️ Không sửa được khoản này");
    }
  };

  // 📷 Gắn ảnh: thu nhỏ trên điện thoại → gửi → tải lại bản tin.
  // `dangGuiAnh` = { id: mã khoản, chu: dòng chữ đang hiện } — một lúc chỉ gửi một tấm.
  const [dangGuiAnh, setDangGuiAnh] = useState(null);

  const ganAnh = async (k, tep) => {
    setDangGuiAnh({ id: k.id, chu: "Đang thu nhỏ ảnh…" });
    try {
      const blob = await thuNhoAnh(tep);
      setDangGuiAnh({
        id: k.id,
        chu: `Đang gửi ảnh… đã thu nhỏ ${veDungLuong(tep.size)} → ${veDungLuong(blob.size)}`,
      });
      await guiAnh(`chi-tieu-khoan/${k.id}/anh`, blob);
      await taiLai();
      noiBao(`✅ Đã gắn ảnh hoá đơn "${k.ten}"`);
    } catch (err) {
      noiBao(
        err.nguoiDung
          ? `⚠️ ${err.message}`
          : err.status === 413
            ? "⚠️ Ảnh quá lớn, chưa gửi được"
            : "⚠️ Chưa gửi được ảnh — thử lại giúp nhé",
      );
    } finally {
      setDangGuiAnh(null);
    }
  };

  const boAnh = async (k) => {
    try {
      await deleteData("chi-tieu-khoan", `${k.id}/anh`);
      await taiLai();
    } catch (err) {
      noiBao("⚠️ Chưa bỏ được ảnh này");
    }
  };

  const xoaKhoan = async (k) => {
    if (!hoiXoa("khoản", k.ten)) return;
    try {
      await deleteData("chi-tieu-khoan", k.id);
      await taiLai();
    } catch (err) {
      noiBao("⚠️ Không xóa được khoản này");
    }
  };

  const luuLoiNhan = async (t) => {
    try {
      await updateData("chi-tieu", t.id, { loi_nhan: loiNhanTam });
      setSuaLoiNhanId(null);
      await taiLai();
    } catch (err) {
      noiBao("⚠️ Không lưu được lời nhắn");
    }
  };

  // Lưu một lượt các số vừa gõ. Chỉ gửi những khoản người ta THẬT SỰ gõ —
  // khoản bỏ trống thì giữ nguyên 0, không đụng tới.
  const luuDienNhanh = async (t) => {
    const canLuu = t.khoan.filter((k) => {
      const v = docSoTien(soDien[k.id]);
      return v !== "" && Number(v) !== Number(k.so_tien);
    });
    if (canLuu.length === 0) {
      setDienNhanhId(null);
      return;
    }
    setDangLuuNhanh(true);
    try {
      for (const k of canLuu) {
        await updateData("chi-tieu-khoan", k.id, { so_tien: docSoTien(soDien[k.id]) });
      }
      setDienNhanhId(null);
      setSoDien({});
      await taiLai();
      noiBao(`✅ Đã điền ${canLuu.length} khoản`);
    } catch (err) {
      noiBao("⚠️ Có khoản chưa lưu được — thử lại giúp nhé");
    } finally {
      setDangLuuNhanh(false);
    }
  };

  const xoaThang = async (t) => {
    if (!hoiXoa("bản tin", veTenThang(t.thang_ma).toLowerCase(), "Các khoản trong đó cũng mất theo."))
      return;
    try {
      await deleteData("chi-tieu", t.id);
      await taiLai();
    } catch (err) {
      noiBao("⚠️ Không xóa được bản tin này");
    }
  };

  if (dangTai) return <DangTai gi="báo chi tiêu" />;

  return (
    <div className="card">
      <h3>💰 Báo chi tiêu</h3>
      <ThongBao bao={bao} />

      <p className="ct-mo-dau">
        Mỗi tháng một bản tin ngắn cho cả nhà biết Ba Mẹ đã chi những mục lớn
        bao nhiêu — để cả nhà biết mà tiết kiệm. Không phải sổ kế toán.
      </p>

      {coTheSoan && (
        <button onClick={() => setMoThang(!moThang)} className="btn-add">
          {moThang ? "❌ Hủy" : "➕ Bản tin tháng mới"}
        </button>
      )}

      {moThang && (
        <form onSubmit={taoThang} className="ct-form-thang">
          <label className="ct-nhan">
            Tháng nào?
            <input
              type="month"
              value={thangMoi}
              onChange={(e) => setThangMoi(e.target.value)}
              className="ct-o"
            />
          </label>
          <label className="ct-nhan ct-nhan-tick">
            <input
              type="checkbox"
              checked={chepKhoan}
              onChange={(e) => setChepKhoan(e.target.checked)}
            />
            Chép sẵn tên các khoản (khoản cố định đến kỳ, hoặc khoản tháng trước), để chỉ việc điền số
          </label>
          <button type="submit" className="nut nut-xanh">Tạo bản tin</button>
        </form>
      )}

      {ds.length === 0 && (
        <p className="ct-trong">
          Chưa có bản tin nào. Tạo bản tin cho tháng này rồi thêm vài khoản lớn —
          tiền điện, học phí, chợ búa. Ba đến năm dòng là đủ.
        </p>
      )}

      {ds.map((t) => (
        <div key={t.id} className="ct-thang">
          <KhoiChiTieu thang={t} />

          {/* 📣 Báo cả nhà — chỉ người soạn được, và chỉ khi bản tin đã có
              khoản: báo cả nhà vào xem một bản tin trống là gọi người ta
              tới xem không có gì. */}
          {coTheSoan && t.khoan.length > 0 && (
            t.da_bao_ca_nha ? (
              <div className="ct-da-bao">
                ✅ <strong>Đã báo cả nhà</strong> lúc {t.da_bao_ca_nha.gio} ngày{" "}
                {t.da_bao_ca_nha.ngay}.
                <br />
                Ai vào xem thì dòng nhắc của người đó tự hết.
                <br />
                <button
                  onClick={() => baoCaNha(t)}
                  disabled={dangBao === t.id}
                  className="ct-nut-bao-lai"
                >
                  {dangBao === t.id ? "Đang báo…" : "📣 Báo lại"}
                </button>
              </div>
            ) : (
              <button
                onClick={() => baoCaNha(t)}
                disabled={dangBao === t.id}
                className="ct-nut-bao"
              >
                {dangBao === t.id ? "Đang báo…" : "📣 Báo cả nhà vào xem"}
              </button>
            )
          )}

          {coTheSoan && dienNhanhId === t.id && (
            <DienNhanh
              tenThang={veTenThang(t.thang_ma).toLowerCase()}
              khoan={t.khoan}
              soDien={soDien}
              onDoiSo={(id, v) => setSoDien((cu) => ({ ...cu, [id]: v }))}
              onLuu={() => luuDienNhanh(t)}
              onThoi={() => { setDienNhanhId(null); setSoDien({}); }}
              dangLuu={dangLuuNhanh}
            />
          )}

          <div className="ct-hang-thao-tac">
            {coTheSoan && dienNhanhId !== t.id && (
              <>
                {themVao === t.id ? (
                  <form onSubmit={(e) => themKhoan(e, t.id)} className="ct-form-khoan">
                    <input
                      type="text"
                      value={tenKhoan}
                      onChange={(e) => setTenKhoan(e.target.value)}
                      placeholder="Tên khoản — Tiền điện…"
                      maxLength={100}
                      className="ct-o"
                      autoFocus
                      list="ds-khoan-co-dinh"
                    />
                    <datalist id="ds-khoan-co-dinh">
                      {tenCoDinh.map((ten) => <option key={ten} value={ten} />)}
                    </datalist>
                    <input
                      type="text"
                      inputMode="numeric"
                      value={soTienKhoan}
                      onChange={(e) => setSoTienKhoan(e.target.value)}
                      placeholder="1.400.000"
                      className="ct-o ct-o-tien"
                    />
                    <button type="submit" className="nut nut-xanh">Thêm</button>
                    <button type="button" onClick={() => setThemVao(null)} className="nut nut-xam">
                      Xong
                    </button>
                  </form>
                ) : (
                  <button onClick={() => { setThemVao(t.id); setTenKhoan(""); setSoTienKhoan(""); }} className="ct-nut-chu">
                    ➕ thêm khoản
                  </button>
                )}

                {t.khoan.length > 0 && (
                  <button
                    onClick={() => { setDienNhanhId(t.id); setSoDien({}); }}
                    className="ct-nut-chu"
                  >
                    ⌨️ điền số hàng loạt
                  </button>
                )}

                {suaLoiNhanId === t.id ? (
                  <div className="ct-form-loi-nhan">
                    <textarea
                      value={loiNhanTam}
                      onChange={(e) => setLoiNhanTam(e.target.value)}
                      placeholder="Lời nhắn cho cả nhà (không bắt buộc)"
                      maxLength={1000}
                      rows={3}
                      className="ct-o"
                    />
                    <div className="ct-hang-nut">
                      <button onClick={() => luuLoiNhan(t)} className="nut nut-xanh">Lưu lời nhắn</button>
                      <button onClick={() => setSuaLoiNhanId(null)} className="nut nut-xam">Thôi</button>
                    </div>
                  </div>
                ) : (
                  <button
                    onClick={() => { setSuaLoiNhanId(t.id); setLoiNhanTam(t.loi_nhan || ""); }}
                    className="ct-nut-chu"
                  >
                    💬 {t.loi_nhan ? "sửa lời nhắn" : "thêm lời nhắn"}
                  </button>
                )}
              </>
            )}

            {coTheSoan && (
              <button onClick={() => xoaThang(t)} className="ct-nut-chu ct-nut-xoa">
                🗑️ xóa bản tin tháng này
              </button>
            )}
          </div>

          {/* Danh sách khoản có nút sửa/xóa — chỉ hiện khi có quyền Sửa,
              để người chỉ đọc không thấy một rừng nút bấm không dùng được. */}
          {/* ⚠️ Danh sách sửa PHẢI nói rõ nó thuộc tháng nào.
              Chủ nhà đã nhầm thật ngày 07/09/2026: danh sách sửa của tháng 9
              nằm ngay bên trên khối "Chi tiêu tháng 8", nên tưởng mình đang
              sửa tháng 8; lưu xong nhìn lại mới thấy là tháng 9.
              Đừng bỏ dòng tiêu đề này đi. */}
          {coTheSoan && dienNhanhId !== t.id && t.khoan.length > 0 && (
            <p className="ct-nhan-khoi">
              Các khoản của {veTenThang(t.thang_ma).toLowerCase()}
            </p>
          )}
          {coTheSoan && dienNhanhId !== t.id && t.khoan.length > 0 && (
            <ul className="ct-danh-sach-khoan">
              {t.khoan.map((k) => (
                <DongKhoan
                  key={k.id}
                  k={k}
                  dangSua={suaKhoanId === k.id}
                  ten={tenSua}
                  soTien={soSua}
                  onDoiTen={setTenSua}
                  onDoiSo={setSoSua}
                  onMoSua={() => { setSuaKhoanId(k.id); setTenSua(k.ten); setSoSua(String(k.so_tien)); }}
                  onLuu={() => luuKhoan(k)}
                  onHuy={() => setSuaKhoanId(null)}
                  onXoa={() => xoaKhoan(k)}
                  suaDuoc={coTheSoan}
                  dangGuiAnh={dangGuiAnh && dangGuiAnh.id === k.id ? dangGuiAnh.chu : null}
                  onGanAnh={(tep) => ganAnh(k, tep)}
                  onBoAnh={() => boAnh(k)}
                />
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
}

export default ChiTieu;
